import { render, staticRenderFns } from "./MerchantFiles.vue?vue&type=template&id=0a16f3ce&scoped=true&"
import script from "./MerchantFiles.vue?vue&type=script&lang=js&"
export * from "./MerchantFiles.vue?vue&type=script&lang=js&"
import style0 from "./MerchantFiles.vue?vue&type=style&index=0&id=0a16f3ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a16f3ce",
  null
  
)

export default component.exports